<ui-modal
  [isOpened]="isModalOpened"
  modalTitle="Save Trade"
  (isOpenedChange)="modalChanged($event)"
>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <div class="save-trade-input-container">
      <label>Client</label>
      <clr-input-container style="display: inline-block">
        <input clrInput formControlName="client" type="text" />
      </clr-input-container>
    </div>

    <div class="save-trade-input-container">
      <label>Trade ID</label>
      <clr-input-container style="display: inline-block">
        <input clrInput formControlName="tradeId" type="text" />
      </clr-input-container>
    </div>

    <div class="save-trade-date-container">
      <label>Trade Date</label>
      <div class="date-container">
        <clr-date-container>
          <input
            type="date"
            clrDate
            placeholder="DD MMM YYYY"
            formControlName="tradeDate"
          />
        </clr-date-container>
      </div>
    </div>

    <div class="save-trade-section-ruler">Optional</div>

    <div class="save-trade-input-container">
      <div class="premium-container">
        <label>Premium</label>
        <div class="premium-currency-container">
          <input
            class="save-trade-premium-input"
            class="clr-input"
            formControlName="premium"
            type="text"
          />
          <app-selector
            [passedItems]="attribute"
            formControlName="premiumCurrency"
          ></app-selector>
        </div>
      </div>
    </div>

    <div class="save-trade-date-container">
      <label>Payment Date</label>
      <div class="date-container">
        <clr-date-container>
          <input
            type="date"
            clrDate
            placeholder="DD MMM YYYY"
            formControlName="premiumPaymentDate"
          />
        </clr-date-container>
      </div>
    </div>

    <div class="save-trade-input-container">
      <label>Payer</label>
      <clr-input-container style="display: inline-block">
        <input clrInput formControlName="premiumPayer" type="text" />
      </clr-input-container>
    </div>

    <div class="save-trade-input-container">
      <label>Counterparty</label>
      <clr-input-container style="display: inline-block">
        <input clrInput formControlName="counterParty" type="text" />
      </clr-input-container>
    </div>

    <div class="save-trade-input-container">
      <label>Status</label>
      <clr-input-container style="display: inline-block">
        <input clrInput formControlName="status" type="text" />
      </clr-input-container>
    </div>

    <div class="save-trade-buttons">
      <div class="saving">
        <loading-spinner *ngIf="savingInfo === 'Saving'"></loading-spinner>
        <div
          *ngIf="savingInfo === 'Saved' || savingInfo === 'Failed'"
          [ngClass]="savingInfo === 'Saved' ? 'success' : 'failed'"
        >
          {{ savingInfo }}
        </div>
      </div>
      <button class="ui-button" (click)="close()">Cancel</button>

      <button
        class="ui-button primary"
        type="submit"
        [ngClass]="this.form.valid ? 'ng-valid' : 'ng-invalid'"
        [disabled]="!this.form.valid"
        [style.cursor]="!this.form.valid ? 'not-allowed' : 'default'"
      >
        Save
      </button>
    </div>
  </form>
</ui-modal>
